import { SET_CANCEL } from 'store/constants/action-types';

const initialState = { isOpen: false, order: null };

export function cancelReducer(state = initialState, action) {
  switch (action.type) {
    case SET_CANCEL:
      return action.payload;
    default:
      return state;
  }
}

export default cancelReducer;
